import LanguageMessages from "./LanguageMessages";

const englishMessages: LanguageMessages = {
    NavBar: {
        HomeTitle: 'Home',
        AccordionsTitle: 'Accordions',
        ContactTitle: 'Contact',
        CompanyTitle: 'Company',
        TeamTitle: 'Team',
        LogoutTitle: 'Logout',
        AccessoriesTitle: 'Accessories',
    },
    RollingCredits: {
        DialogTitle: 'Manage Text',
    },
    Footer: {
        firm: "Firma",
        addressLineOne: "Generalvertretungen Schweiz",
        addressLineTwo: "PIGINI & EXCELSIOR",
        addressLineThree: "Martin Frey",
        address: "Untere Holzstrasse 9",
        plz: '5036',
        city: 'Oberentfelden',
        telephone: 'Festnetz: +41 62 827 21 61',
        mobile: 'Mobil: +41 79 239 77 94',
        emailLabel: 'E-Mail:',
        email: 'info@pigini.ch'
    },
    HomePage: {
        HomeShopShortcut: {
            titleText: 'Explore our fine selection of accordions, featuring specially curated pieces from Pigini and Excelsior Accordions. Experience the charm and craftsmanship of these beautifully designed instruments. Immerse yourself in the world of these masterfully crafted, artistic instruments.'
        }
    },
    TeamPage: {
        title: 'Team',
        teamMembers: [{
            name: 'Martin Frey',
            text: [
                '',
                '[[[bold]]]Education',
                'University Department of Civil Engineering (Brugg-Windisch / CH)',
                '- Graduate Civil Engineer HTL (later FH) Graduate Civil Engineer HTL (later FH)',
                'Postgraduate studies:',
                '- MAS-ND-U (Business Management / Lucerne University of Applied Sciences and Arts in Horw-Lucerne / CH)',
                '- MAS-CIM (Computer Integrated Manufacturing / Brugg-Windisch / CH)',
                '',
                '[[[bold]]]Project manager & Engineering',
                'Many years of experience in national civil and structural engineering, international experience in the machine industry (including the manufacture of accordions), the automotive supplier industry, aerospace engineering, robotics.',
                'Many years of experience in national and international consulting and process modelling and simulation projects (Aeneis, Six Sigma, Wassermann {process simulation} SAP-R3), SOX and IKS systems.',
                'National and international process projects in large energy production companies.',
                '',
                '[[[bold]]]International music experience',
                'Organizer of concerts and seminars in various directions and genres, including accordion concerts. (Friedrich Lips, Viacheslav Semjonov, Yuri Shishkin, Frank Marocco, Timbre Russian Accordions Group of Moscow, Pavel Smirnov\'s orchestra, accordion orchestra from New Zealand, Frank Marocco, Fang Yuan, etc.)',
                '',
                '[[[bold]]]General agency for accordion musical instruments',
                'for the world\'s leading manufacturer of high-end accordions of the brands PIGINI & EXCELSIOR for around 35 years',
                '- 35 years in Switzerland & Liechtenstein (owner of the general agency)',
                '- around 10 years in Russia (operational management of the general agency)'
            ]
        }]
    },
    CompanyPage: {
        AboutUs: {
            title: 'About Us',
            pAndSSwitzerland: {
                subtitle: 'PIGINI & EXCELSIOR Switzerland',
                text: 'State of the art in accordion construction. Perfect harmony of tradition, innovation and the absolute pursuit of quality. PIGINI relies unconditionally on the years of experience of Italy\'s most talented instrument builders.',
            },
            relationships: {
                subtitle: 'Relationships',
                text: 'In order to build the absolute instruments possible, PIGINI fosters close relationships with the world\'s foremost soloists, orchestras, conservatories, schools and teachers. These relationships, cultivated via PIGINI\'s global network of distributors, are key to building accordions without equal.',
            },
            since: {
                subtitle: 'PIGINI & EXCELSIOR Switzerland since 1990',
                text: 'In 1990, PIGINI Switzerland committed to the philosophy of PIGINI and EXCELSIOR and has been providing accordions of top quality ever since, along with customer service which does justice to instruments of such class. We are proud to offer you instruments which leave nothing to be desired regarding sound and quality.',
            },
            ourService: {
                subtitle: 'Our Service',
                text: 'Feel free to make use of our services. Whether you have individual wishes when buying an instrument or whether you wish to rent an accordion, we pledge to provide you with competent and honest advice.'
            },
            comeSee: {
                subtitle: 'Come and See for Yourself',
                text: 'We would be delighted to have you come visit us and try out our accordions yourself. At PIGINI & EXCELSIOR Switzerland you are welcomed by people enthusiastic about accordions and accordion music. We invite you to our world!',
            },
        },
        AboutPigini: {
            title: 'About Pigini',
            tradition: {
                subtitle: 'Tradition',
                text: 'On the 6th of June 1946 Filippo Pigini registered the firm "F.lli PIGINI di Filippo" at the Chamber of Commerce of Ancona, together with his sons Adriano, Gino, Luigi and Marino as partners. Filippo Pigini, a man with extraordinary entrepreneurial spirit, ensured that his sons, who had just returned from the war, could resume work in the family\'s joiner\'s shop which had been founded in 1930.'
            },
            foundingYears: {
                subtitle: 'The Founding Years',
                text: 'The years immediately following the war were hard, but driven by the need to earn their livelihoods along with their passion drove the Pigini\'s to found one of the most dynamic accordion factories in the business.\n' +
                    '\n' +
                    'The first deliveries were shipped to the United States, after that to Canada, Sweden, Denmark, Argentina, Egypt and Pakistan. The international spirit that inhabits PIGINI today was evident right from the business\' founding years.',
            },
            ginoPigini: {
                subtitle: 'Gino Pigini',
                text: 'Leading the company fell to Gino Pigini for several years, who had been an expert "Vociarolo" (reed maker) since the age of 14. He put great trust into the next generation\'s creative spirit and their ambition to learn. Within short time he had put together a group of extraordinary accordion builders. His efforts and his work philosophy are to this day the foundation on which the quality associated with PIGINI is built.',
            },
            philosophy: {
                subtitle: 'Philosophy',
                text: '"Interpret the future making the most of the past".\n' +
                    '\n' +
                    'With this spirit the PIGINI team faces each challenge. They conceive passionatey the accordion as a musical instrument in which art and technique are given equal importance by that deeply rooted expertise that comes only from experience.\n' +
                    '\n' +
                    'For decades the best music schools and the most well known virtuoso accordionists have confirmed the prestige of Pigini instruments throughout the world. Such fame can only be based on solid roots of excellent quality which makes PIGINI the leading brand name in this sector.',
            },
            craftsmanship: {
                subtitle: 'Craftmanship',
                text: 'PIGINI accordions are built according to an old artisan tradition which, however, now makes use of the most up-to-date technologies so that centuries of experience can he applied to advanced production techniques.'
            },
            topQualityMaterials: {
                subtitle: 'Top Quality Materials',
                text: 'Every instrument produced by PIGINI is a work of art made with very special materials. The wood is carefully chosen. The reeds, which represent the soul of the instrument, are produced within the company itself and are famous throughout the world for their quality sound. The bellows produce the ideal pressure for the instruments thanks to the special cardboard pulp which is used to build them. Varnish, felts and skins are all carefully selected in order to create an instrument where every single detail has been checked for quality.',
            },
            careForDetail: {
                subtitle: 'Care for Detail',
                text: 'Beauty and richness of sound can only be guaranteed when even the smallest mechanical noise can be avoided. This is why each part of the mechanism in PIGINI accordion is covered in felt which gives the instruments that special clarity and purity of sound recognized by every specialist in the field of music.',
            },
            selection: {
                subtitle: 'Wide Selection of Models',
                text: 'The range of 60 different models shown in the Pigini catalog is able to cover the most varied requirements and has been created following the idea that an instrument must suit its user, whether he is a young beginner or a well established concert player. Thanks to their features PIGINI accordions accompany both amateurs and professionals throughout their studies.',
            },
            qoi: {
                subtitle: 'Quality of Investment',
                text: 'The craftsmanship and the exclusive materials employed make each Pigini accordion a long lasting and stainless quality investment. Therefore each accordion is a unique and original piece, its value can only rise with the passing of the time.',
            },
            uniqueness: {
                subtitle: 'Uniqueness',
                text: 'A small screw, the mere cutting of wood, the balance of dimensions, the thickness of the felts, the smoothness of the running levers, the calibration of the springs... Everyone at PIGINI strives to perfect those hidden details which although not visible, are clearly noticeable in the final product\'s refined touch.',
            },
            touch: {
                subtitle: 'Touch',
                text: 'Behind the long-lasting, solid fame of Pigini instruments, there has been the search for a refined, fascinating sound which could match the needs of the music itself as well as the musician\'s own passion.\n' +
                    '\n' +
                    'The result is a unique touch which distinguishes every Pigini accordion.\n' +
                    '\n' +
                    'This rare privilege bestows on each instrument a special significance and importance.',
            }
        },
        AboutExcelsior: {
            title: 'About Excelsior',
            beginnings: {
                subtitle: 'The Beginnings',
                text: 'The Excelsior Company was established in New York in 1924. The high quality of accordions manufactured by Excelsior made it quickly popular throughout the United States.\n' +
                    '\n' +
                    'The greatest popularity of Excelsior accordions was reached after the Second World War as they became a "must" for any big orchestra: Charles Magnante, Art Van Damme, Pietro Deiro Jr., are just a few among the many prominent players who chose Excelsior.',
            },
            expansion: {
                subtitle: 'Expansion',
                text: 'In 1948 a new plant was established in Castelfidardo, Italy, to expand production and sales. Since then excellent sound, quality and fine look of Excelsior accordions have been appreciated all over the world.',
            },
            heritage: {
                subtitle: 'Heritage',
                text: 'Today Excelsior goes ahead in its tradition of quality and prestige. The Excelsior accordions are still built with selected materials and according to the best traditional craftmenship methods.\n' +
                    '\n' +
                    'To own an Excelsior accordion today means to own a prestigious instrument and ideally to follow the paths of the best and most popular accordion artist of past and present.',
            },
        },
        Consultations: {
            title: 'Consultations',
            appointments: {
                subtitle: 'Appointments',
                text: 'Have we piqued your interest? Then contact us for an appointment at our seat of business in Oberentfelden. We look forward to your visit.'
            },
            wideSelection: {
                subtitle: 'Wide Selection',
                text: 'We always have a selection of instruments in stock which you may try out to your heart\'s delight. This ensures that you can make a well-informed decision and pick exactly the accordion which best suits your needs.',
            },
            service: {
                subtitle: 'Competent and Honest Service',
                text: 'As a veteran accordionist himself and someone who has maintained good relationships to some of the world\'s foremost accordion virtuosos, Martin Frey is ideally suited to give you competent and honest advice and to provide you exactly what you need.',
            }
        },
        Rentals: {
            title: 'Rentals',
            subtitle: 'When Buying Is Not the Right Option...',
            text: 'Especially for children who are still going to school and growing it often does not make sense to purchase an accordion.\n' +
                '\n' +
                'For these Situations we offer a variety of instruments as rentals. This ensures that pupils always have available an instrument which is ideally suited to their size and needs.',
        },
        Repairs: {
            title: 'Repairs',
            subtitle: 'When Something Needs Fixing',
            text: 'If over the years something does indeed break or an instrument needs to be retuned, we provide competent and fast service.',
        }
    },
    ContactPage: {
        ContactUsCardTitle: 'Send information request',
        ContactUsCardDescription: 'You can also contact us by e-mail: [[[mailto]]]info@pigini.ch or by phone: +41 79 239 77 94',
        areasOfInterest: {
            areasOfInterestTitle: 'Areas of Interest',
            sendFurtherInformationChecboxLabel: 'Please send me further information on your instruments.',
            contactMeForTryOutCheckboxLabel: 'Please contact me regarding an appointment for trying out instruments in which I might be interested.',
            interestedInRentingCheckboxLabel: 'I\'m interested in renting an instrument. Please contact me with further details.'
        },
        contactInformation: {
            titleLabel: 'Title',
            titleMrValueLabel: 'Mr.',
            titleMsValueLabel: 'Ms.',
            firstNameLabel: 'First Name',
            lastNameLabel: 'Last Name',
            streetLabel: 'Street',
            houseNumberLabel: 'House Number',
            zipLabel: 'Zip Code',
            cityLabel: 'City',
            phoneLabel: 'Phone',
            mobileLabel: 'Mobile',
            emailLabel: 'E-Mail',
            preferredMethodOfContactLabel: 'Preferred method of contact',
            additionalInformationTitle: 'Additional information (optional)',
            sendButtonLabel: 'send'
        }
    },
    AccordionsPage: {
        titleToBuy: 'Accordions to purchase',
        titleToRent: 'Accordions to rent',
        Filter: {
            resetFilterBtnLabel: 'Reset filter',
            brandTitle: 'Brand',
            generalCategoryTitle: 'General',
            rightHandCategoryTitle: 'Right hand',
            leftHandCategoryTitle: 'Left hand',
            standardBassCategoryTitle: 'Standard bass',
            characteristicsCategoryTitle: 'Characteristics',
            freeBassCategoryTitle: 'Free bass',
            isRental: 'Rental',
            Condition: {
                title: 'Condition',
                used: 'Used',
                new: 'New',
            },
            BassType: {
                title: 'Bass Type',
                convertor: 'Convertor',
                standard: 'Standard',
            },
            RightHandSystem: {
                title: 'System',
                keys: 'Piano',
                buttons: 'Button'
            },
            Weight: {
                title: 'Weight'
            },
            Height: {
                title: 'Height'
            },
            Width: {
                title: 'Width',
            },
            Rows: {
                title: 'Rows'
            },
            RightHandButtons: {
                title: 'Notes buttons',
            },
            RightNotesPiano: {
                title: 'Notes piano',
            },
            ChorusRight: {
                title: 'Chorus'
            },
            CassottoRight: {
                title: 'Cassotto',
            },
            RegisterRight: {
                title: 'Registers'
            },
            ChinSwitches: {
                title: 'Chin switches'
            },
            StandardBassChorus: {
                title: 'Chorus',
            },
            RegisterSb: {
                title: 'Registers'
            },
            FreeBassNotes: {
                title: 'Notes',
            },
            ChorusFb: {
                title: 'Chorus',
            },
            ReedsFilter: {
                title: 'Reeds',
                tam: 'Tipo a Mano',
                fam: 'Handmade',
                durall: 'Durall',
                turbo: 'Turbo',
                none: 'None'
            }
        },
        DeleteAccordion: {
            ConfirmationDialogTitle: 'Delete accordion',
            ConfirmationDialogContent: 'Are you sure you want to delete the accordion? Once deleted, you have to contact the administrator for restoring it. Data may still be lost during this process.\n',
        },
        PublishAccordion: {
            ConfirmationDialogTitle: 'Publish Accordion',
            ConfirmationDialogContent: 'Are you sure you want to publish the accordion? Once published, everyone can see this accordion in the store. Only the administrator can "unpublish" it',
        },
        UnpublishAccordion: {
            ConfirmationDialogTitle: 'Unpublish Accordion',
            ConfirmationDialogContent: 'Are you sure you want to unpublish this accordion? After this action, the public will not be able to see this accordion anymore, until published again.',
        },
        ImageManager: {
            setAsThumbnailButtonLabel: 'Set as thumbnail',
        },
        accordionNotFoundText: 'Accordion not found',
        accordionAdditionalInformationContactText: 'I`m interested in the accordion',
    },
    AccessoriesPage: {
        title: 'Accessories',
        subtitle: 'Discover the perfect additions to enhance your accordion experience with our extensive selection of accessories. If something catches your eye, please feel free to reach out to us directly. Additionally, if you\'re searching for a specific accessory not featured in our collection, do not hesitate to contact us. We are committed to fulfilling your needs and ensuring you find exactly what you\'re looking for.',
        Backpacks: {
            title: 'Backpacks',
            text:  'Elevate your musical journey with our high-quality backpacks designed specifically for accordions and CH-Örgeli. These backpacks are not just about carrying convenience; they offer robust protection and stylish design to complement your instrument. Whether you’re a professional musician or a passionate enthusiast, our backpacks ensure that your accordion or CH-Örgeli travels in comfort and style. Explore our range of backpacks that embody durability, elegance and practical details.',
            tableData: {
                columnKeyDef: ['text', 'currency', 'price' ],
                columnNameDef: ['', '', 'Price'],
                rows: [
                    { text: 'Backpack accordion cordura'    , price: 'From 63'  , currency: 'CHF / Euro' },
                    { text: 'Backpack CH-Örgeli'            , price: 'From 90'  , currency: 'CHF / Euro' },
                    { text: 'Backpack soft plush Concertina', price: 'From 70'  , currency: 'CHF / Euro' },
                ]
            }
        },
        ShoulderStraps: {
            title: 'Shoulder Straps',
            text: 'Discover our diverse range of shoulder straps for accordions, available with and without cross straps. Designed to meet the unique needs of every musician, our shoulder straps come in various sizes, ensuring a perfect fit and unmatched comfort. Whether you prefer the enhanced stability of a cross strap or the simplicity of a traditional design, our straps provide the support you need to play your instrument with ease and style.',
            tableData: {
                columnKeyDef: ['text', 'paddingWidth', 'currency', 'price' ],
                columnNameDef: ['', '', '', 'Price'],
                rows: [
                    { text: 'Shoulder strap without cross-strap', price: 'From  50', currency: 'CHF / Euro'  , paddingWidth: '45 mm' },
                    { text: 'Shoulder strap with cross-strap'   , price: 'From  79', currency: 'CHF / Euro'  , paddingWidth: '50 mm' },
                    { text: 'Shoulder strap with cross-strap'   , price: 'From 100', currency: 'CHF / Euro'  , paddingWidth: '70 mm' },
                    { text: 'Shoulder strap wwith cross-strap'  , price: 'From 100', currency: 'CHF / Euro'  , paddingWidth: '80 mm' },
                ]
            }
            
        },
        AccordionDustCovers: {
            title: 'Dust Covers',
            text: 'Protect your accordion from dust and minor scratches with our selection of dust covers, available in small, medium, and sizes suitable for converters. These covers are crafted to offer a snug fit, ensuring that every part of your instrument is shielded from the elements. Ideal for storage and everyday protection, our dust covers maintain the pristine condition of your musical instruments while not in use. Explore our range to find the perfect cover that matches your needs.',
            tableData: {
                columnKeyDef: ['text', 'currency', 'price' ],
                columnNameDef: ['', '', 'Price'],
                rows: [
                    { text: 'Accordion dust cover small'    , price: '20', currency: 'CHF / Euro' },
                    { text: 'Accordion dust cover middle'   , price: '20', currency: 'CHF / Euro' },
                    { text: 'Accordion dust cover large'    , price: '20', currency: 'CHF / Euro' },
                ]
            }
        },
        AccordionGloveLeftHand: {
            title: 'Left Hand Glove for Accordions',
            text: 'Experience enhanced comfort and control with our specially designed Left Hand Glove for accordion players. Originally invented to protect the musician\'s hand from the constant friction and pressure of operating the bass buttons, these gloves also help in maintaining a consistent temperature, preventing sweat from affecting the performance. Our Left Hand Glove is crafted from high-quality materials that ensure both durability and flexibility, allowing you to play for extended periods without discomfort.',
            tableData: {
                columnKeyDef: ['text', 'currency', 'price' ],
                columnNameDef: ['', '', 'Price'],
                rows: [
                    { text: 'Accordion glove left hand', price: '35', currency: 'CHF / Euro' }
                ]
            }
        }
    },
    ConfirmationDialog: {
        DefaultDialogTitle: 'Please confirm',
        DefaultDialogContent: 'Please confirm your proposed action',
    },
    GeneralComponentLabels: {
        notes: 'Notes',
        range: 'Range',
        from: 'From',
        to: 'To',
        deleteButtonLabel: 'Delete',
        cancelButtonLabel: 'Cancel',
        createButtonLabel: 'Create',
        publishButtonLabel: 'Publish',
        unpublishButtonLabel: 'Unpublish',
        manageImagesButtonLabel: 'Manage Images',
        closeButtonLabel: 'Close',
        backButtonLabel: 'Back',
        speed: 'Speed',
        paddingWidth: 'Padding width',
        price: 'Price',
        product: 'Product',
        currency: 'Currency',
    },
    ShopShortcut: {
        buy: 'Purchase',
        rent: 'Rent',
    }
}

export default englishMessages;